import { render } from "./EarnVaultDeposit.vue?vue&type=template&id=4028246f&scoped=true"
import script from "./EarnVaultDeposit.vue?vue&type=script&lang=js"
export * from "./EarnVaultDeposit.vue?vue&type=script&lang=js"

import "./EarnVaultDeposit.vue?vue&type=style&index=0&id=4028246f&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4028246f"],['__file',"resources/js/components/EarnVaultDeposit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4028246f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4028246f', __exports__)) {
    api.reload('4028246f', __exports__)
  }
  
  module.hot.accept("./EarnVaultDeposit.vue?vue&type=template&id=4028246f&scoped=true", () => {
    api.rerender('4028246f', render)
  })

}


export default __exports__